/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "accordian-arrow",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fillRule": "evenodd",
                "clipRule": "evenodd",
                "fill": "#666666"
            },
            "accordianArrow": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "8.7",
            "height": "12.6"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 8.7 12.6", className: "accordian-arrow", width: this.props.width, height: this.props.height, style: this.props.accordianArrow },
            _react2["default"].createElement("path", { className: "st0", d: "M8.4 7l-6.7 5.1c-1.1 1-1.7.2-1.7-.8v-10C0 .3.6-.4 1.7.4l6.7 5.1c.5.4.5 1.1 0 1.5z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/accordian-arrow.js